import Phaser from 'phaser';
import { SCENE_KEYS } from '../data/gameConstants';
import { ResponsiveSystem } from '../systems/ResponsiveSystem';
import { SaveSystem } from '../systems/SaveSystem';
import { SceneTransition } from '../utils/SceneTransition';
import { Button } from './Button';
import { UIStyle } from './UIStyle';

/** Tombol menu zona — kiri atas, klik untuk buka pilihan aksi */
export function addZoneMenuButton(scene: Phaser.Scene): Button {
  const isMobile = ResponsiveSystem.isMobile(scene);
  const toggleButtonWidth = isMobile ? 112 : 100;
  const toggleButtonHeight = isMobile ? 46 : 40;
  const safe = ResponsiveSystem.getSafeBounds(scene.game, {
    left: isMobile ? 20 : 24,
    top: isMobile ? 18 : 20,
  });
  const sceneKey = scene.scene.key;
  const currentZone = SaveSystem.getZoneForScene(sceneKey);
  let menuOpen = false;

  const overlay = scene.add.rectangle(
    scene.scale.width / 2,
    scene.scale.height / 2,
    scene.scale.width,
    scene.scale.height,
    0x000000,
    0.16,
  );
  overlay.setScrollFactor(0).setDepth(118).setVisible(false);

  const panelWidth = isMobile ? 228 : 212;
  const panelHeight = isMobile ? 214 : 196;
  const panelX = safe.left + panelWidth / 2;
  const panelTop = safe.top + toggleButtonHeight + (isMobile ? 22 : 18);
  const panelY = panelTop + panelHeight / 2;
  const panel = UIStyle.createModalSurface(scene, panelX, panelY, panelWidth, panelHeight);
  panel.setScrollFactor(0).setDepth(119).setVisible(false);

  const title = scene.add.text(panelX, panelTop + 16, 'Menu', {
    ...UIStyle.panelTitle(isMobile ? UIStyle.px(20) : UIStyle.px(19)),
  }).setOrigin(0.5, 0).setDepth(125).setScrollFactor(0).setVisible(false);
  const divider = scene.add.rectangle(
    panelX,
    panelTop + (isMobile ? 44 : 42),
    panelWidth - 32,
    2,
    0xd4a373,
    0.36,
  ).setDepth(125).setScrollFactor(0).setVisible(false);

  let continueBtn!: Button;
  let restartBtn!: Button;
  let mainMenuBtn!: Button;

  const setMenuVisible = (visible: boolean) => {
    menuOpen = visible;
    const setControls = scene.data.get('setMobileControlsVisible') as ((v: boolean) => void) | undefined;
    setControls?.(!visible);
    overlay.setVisible(visible);
    panel.setVisible(visible);
    title.setVisible(visible);
    divider.setVisible(visible);
    continueBtn.setVisible(visible);
    restartBtn.setVisible(visible);
    mainMenuBtn.setVisible(visible);
  };

  continueBtn = new Button(scene, {
    x: panelX,
    y: panelTop + (isMobile ? 72 : 66),
    text: 'Lanjutkan',
    width: isMobile ? 170 : 156,
    height: isMobile ? 42 : 38,
    fontSize: isMobile ? UIStyle.px(16) : UIStyle.px(15),
    depth: 125,
    touchPadding: isMobile ? 8 : 6,
    onClick: () => setMenuVisible(false),
  });

  restartBtn = new Button(scene, {
    x: panelX,
    y: panelTop + (isMobile ? 120 : 110),
    text: 'Ulangi Zona',
    width: isMobile ? 170 : 156,
    height: isMobile ? 42 : 38,
    fontSize: isMobile ? UIStyle.px(16) : UIStyle.px(15),
    depth: 125,
    touchPadding: isMobile ? 8 : 6,
    onClick: () => {
      setMenuVisible(false);
      SceneTransition.restartCurrentZone(scene);
    },
  });

  mainMenuBtn = new Button(scene, {
    x: panelX,
    y: panelTop + (isMobile ? 168 : 154),
    text: 'Menu Utama',
    width: isMobile ? 170 : 156,
    height: isMobile ? 42 : 38,
    fontSize: isMobile ? UIStyle.px(16) : UIStyle.px(15),
    depth: 125,
    touchPadding: isMobile ? 8 : 6,
    onClick: () => {
      setMenuVisible(false);
      SaveSystem.saveProgress(sceneKey, currentZone);
      SceneTransition.startNextFrame(scene, SCENE_KEYS.MAIN_MENU);
    },
  });

  continueBtn.setVisible(false);
  restartBtn.setVisible(false);
  mainMenuBtn.setVisible(false);
  continueBtn.getContainer().setScrollFactor(0);
  restartBtn.getContainer().setScrollFactor(0);
  mainMenuBtn.getContainer().setScrollFactor(0);

  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    overlay.destroy();
    panel.destroy();
    title.destroy();
    divider.destroy();
    continueBtn.destroy();
    restartBtn.destroy();
    mainMenuBtn.destroy();
  });

  const toggleBtn = new Button(scene, {
    x: safe.left + toggleButtonWidth / 2,
    y: safe.top + toggleButtonHeight / 2,
    text: 'Menu',
    width: toggleButtonWidth,
    height: toggleButtonHeight,
    fontSize: isMobile ? UIStyle.px(16) : UIStyle.px(15),
    depth: 126,
    onClick: () => setMenuVisible(!menuOpen),
  });
  toggleBtn.getContainer().setScrollFactor(0);
  return toggleBtn;
}
